// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__33obr","legacyBtn":"MutateMid_legacyBtn__1STRC"};